'use strict';

import config from 'config';
import React, { Component } from 'react';
import CardContainer from 'components/CardContainer';
import ActionButton from 'components/ActionButton';
import GreetingsSvg from 'components/GreetingsSvg';
import { log } from 'utils';
import { connect } from 'react-redux'
import zChat from 'vendor/web-sdk';

const { LABELS } = config;

class PrechatForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sent: false
    };
    this.send = this.send.bind(this);
    this.renderChild = this.renderChild.bind(this);
    this.onInvalid = this.onInvalid.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
  }

  onFocusIn(event) {
    const pInput = event.target.parentNode.parentNode;

    pInput.classList.add( 'yith-field-filled' );
  }

  onFocusOut(event) {
    const pInput = event.target.parentNode.parentNode,
      input = pInput.querySelector( 'input, textarea' );

    this.removeError( event.target );

    if ( ! input.value ) {
      pInput.classList.remove( 'yith-field-filled' );
    }
  }

  onInvalid( event ) {
    const input = event.target;

    this.reportError( input );
  }

  removeError( node ) {
    if ( !! node.target ) {
      node = node.target;
    }
    const pInput = node.parentNode.parentNode;

    if ( ! pInput ) {
      return;
    }

    pInput.classList.remove( 'yith-field-required' );
  }

  reportError( node ) {
    if ( !! node.target ) {
      node = node.target;
    }
    const pInput = node.parentNode.parentNode;

    if ( ! pInput ) {
      return;
    }

    pInput.classList.add( 'yith-field-required' );
  }

  send(event) {
    event.preventDefault();

    // check specifically for hidden checkboxes
    if ( ! this.refs.policy_chat.checked ) {
      this.reportError( this.refs.policy_chat );
    }

    // Use HTML form validation to validate inputs
    const form = this.refs.form;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const msg = this.refs.message.value;

    // Don't send empty messages
    if (!msg) return;

    zChat.setVisitorInfo({
      email: this.refs.email.value
    }, (err) => {
      if (err) return;

      zChat.sendChatMsg(msg, (err) => {
        if (err) log('Error sending message');
      })
    });

    this.props.dispatch({
      type: 'synthetic',
      detail: {
        type: 'visitor_send_msg',
        msg: msg
      }
    });
  }

  renderChild() {
    return (
      <form ref="form" key="not-sent" className="offline-form">
        <div className="form-content">
          <p className={`form-row form-row-wide ${this.props.userEmail ? 'yith-field-filled' : ''}`}>
            <label className="label">
              {LABELS.email_field_label || 'Email'}
              <abbr className="required" title="required">*</abbr>
            </label>
            <span className="woocommerce-input-wrapper">
              <input className="input-text" required ref="email" type="email" pattern={`${zChat.EMAIL_REGEX.source}`} onFocus={this.onFocusIn} onBlur={this.onFocusOut} onInvalid={this.onInvalid} defaultValue={this.props.userEmail} />
            </span>
          </p>
          <p className="form-row form-row-wide">
            <label className="label">
              {LABELS.message_field_label || 'Message'}
              <abbr className="required" title="required">*</abbr>
            </label>
            <span className="woocommerce-input-wrapper">
              <textarea className="input-text" required ref="message" onFocus={this.onFocusIn} onBlur={this.onFocusOut} onInvalid={this.onInvalid} />
            </span>
          </p>
          <p className="terms-section">
              <label className="policy-chat">
                <input type="checkbox" ref="policy_chat" value="yes" onChange={this.removeError} required data-cons-preference="privacy_policy"/>
                <span>&nbsp;</span>
                {LABELS.policy_field_label || 'I have read and accept the'} <strong><a href="#" rel="nofollow" data-toggle="modal" data-type="privacy-policy" title="{LABELS.policy_field_title || 'Our Privacy Policy'}">{LABELS.policy_field_anchor || 'Privacy Policy'}</a></strong>.
              </label>
            </p>
        </div>
        <div className="button-container">
          <ActionButton
            addClass="button-send btn btn-flat-green"
            label={LABELS.start_chat_button || 'Start Chat'}
            onClick={this.send}
          />
        </div>
      </form>
    );
  }

  render() {
    return (
      <CardContainer title={LABELS.presale_chat_default_title || 'Presale questions? Chat with us!'} addClass="offline-card" icon={ <GreetingsSvg /> } contentAddClass={this.state.sent ? 'sent' : ''}>
        {this.renderChild()}
      </CardContainer>
    );
  }
}


PrechatForm.displayName = 'PrechatForm';
PrechatForm.propTypes = {
  onClick: React.PropTypes.func,
  addClass: React.PropTypes.string
};

export default connect()(PrechatForm);



// WEBPACK FOOTER //
// ./src/components/PrechatForm.js